import { render, staticRenderFns } from "./room-detail-popover.vue?vue&type=template&id=16553337&scoped=true&"
import script from "./room-detail-popover.js?vue&type=script&lang=js&"
export * from "./room-detail-popover.js?vue&type=script&lang=js&"
import style0 from "./room-detail-popover.scss?vue&type=style&index=0&id=16553337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16553337",
  null
  
)

export default component.exports